/* Mobile footer accordion */
if (!customElements.get('mimicri-footer')) {
  customElements.define(
    'mimicri-footer',
    class MimicriFooter extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.mimicri-footer__accordion-trigger').forEach((btn) => {
          btn.addEventListener('click', () => this.toggle(btn));
        });

        /* Desktop: Business Info toggle */
        const bizToggle = document.querySelector('.mimicri-footer__business-toggle');
        const bizInfo = document.querySelector('.mimicri-footer__business-info');
        if (bizToggle && bizInfo) {
          bizToggle.addEventListener('click', () => {
            const isOpen = bizToggle.getAttribute('aria-expanded') === 'true';
            bizToggle.setAttribute('aria-expanded', String(!isOpen));
            bizInfo.classList.toggle('is-open', !isOpen);
          });

          document.addEventListener('click', (e) => {
            if (!bizToggle.contains(e.target) && !bizInfo.contains(e.target)) {
              bizToggle.setAttribute('aria-expanded', 'false');
              bizInfo.classList.remove('is-open');
            }
          });
        }
      }

      toggle(btn) {
        const item = btn.closest('.mimicri-footer__accordion-item');
        const icon = btn.querySelector('.mimicri-footer__accordion-icon');
        const content = item.querySelector('.mimicri-footer__accordion-content');
        const isOpen = item.classList.contains('is-open');

        /* Close all */
        this.querySelectorAll('.mimicri-footer__accordion-item').forEach((el) => {
          el.classList.remove('is-open');
          const trigger = el.querySelector('.mimicri-footer__accordion-trigger');
          const panel = el.querySelector('.mimicri-footer__accordion-content');
          const ic = el.querySelector('.mimicri-footer__accordion-icon');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (panel) panel.setAttribute('aria-hidden', 'true');
          if (ic) ic.textContent = '+';
        });

        /* Open clicked (unless it was already open) */
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (content) content.setAttribute('aria-hidden', 'false');
          if (icon) icon.textContent = '-';
        }
      }
    }
  );
}
